import React from 'react';
import { ListGroup } from 'react-bootstrap';

const ListGroupWikiItem = ({ array }) => (
    <ListGroup id="list-group">
        {
            array.map((el, idx) =>
                el.length > 1 ? (
                    <>
                        {el.map((e, i) =>
                            i === 0 ? (
                                <ListGroup.Item key={i}
                                    className="fw-bold"
                                    action
                                    rel="noopener noreferrer"
                                    href={`#${idx}0`}
                                >
                                    {idx}. {el[0].name}
                                </ListGroup.Item>
                            ) : (
                                e.name &&
                                <ListGroup.Item key={i}
                                    className="fw-normal"
                                    action
                                    rel="noopener noreferrer"
                                    href={`#${idx}0`}
                                >
                                    {`${idx}.${i} ${e.name}`}
                                </ListGroup.Item>
                            )
                        )}
                    </>
                ) : (
                    <ListGroup.Item key={idx}
                        className="fw-bold"
                        action
                        rel="noopener noreferrer"
                        href={`#0${idx}`}
                    >
                        {el[0].name}
                    </ListGroup.Item>
                )
            )
        }
    </ListGroup>

);

export default ListGroupWikiItem;
